import { Link, useActionData } from "react-router-dom";
import "./about.scss";
import { useEffect } from "react";
import { gsap } from "gsap-trial";
const About = () => {
    useEffect(() => {
        const timeline = gsap.timeline({});

        timeline
            .fromTo(
                ".about-one",
                { opacity: 0 },
                { opacity: 1, duration: 1, ease: "power2.out" }
            )
            .fromTo(
                ".about-two",
                { clipPath: "polygon(0 0, 0 0, 0 100%, 0 100%)" },
                {
                    clipPath: "polygon(0 0, 100% 0, 100% 100%, 0 100%)",
                    duration: 1,
                    ease: "power2.out",
                },
                "<"
            );
    }, []);
    return (
        <>
            <div className="contain-wrapper">
                <div className="about-one contain">
                    <p>
                        Home / <span className="volt">About us</span>
                    </p>
                    <h1>Space that embraces the industrious</h1>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="about-two contain">
                    <video
                        src="https://player.vimeo.com/progressive_redirect/playback/1049509482/rendition/720p/file.mp4?loc=external&signature=85e21cdef16ace72467c9b4e46ac0c4cc0756732eb8d16f4f8db3ac935ffd60e"
                        poster="../images/about/1.jpg"
                        autoPlay
                        muted
                        loop
                        playsInline
                    ></video>
                </div>
            </div>
            <div className="contain-wrapper">
                <div className="about-three contain">
                    <div className="space-holder"></div>
                    <div className="copy-wrapper">
                        <h3>
                            Space Industrial is a joint venture between &nbsp;
                            <br />
                            Marchmont and Invesco Real Estate. A dedicated
                            partnership &nbsp;
                            <br />
                            experienced in delivering space for business.
                        </h3>
                        <div className="investment-wrapper">
                            <Link
                                target="_top"
                                className="investment"
                                to="https://www.marchmont-im.com/"
                            >
                                <img
                                    src="../images/about/marchmont.svg"
                                    alt="marchmont"
                                />
                                <p className="copy">
                                    Marchmont are an industrial and logistics
                                    specialist, with extensive experience in
                                    acquiring, managing and delivering quality
                                    space for occupiers in the warehouse and the
                                    logistics sector.
                                </p>
                                <div className="link-wrapper">
                                    <p className="volt">View website</p>
                                    <div className="parallelogram-small"></div>
                                </div>
                            </Link>
                            <Link
                                target="_top"
                                className="investment"
                                to="https://www.invesco.com/uk/en/home.html"
                            >
                                <img
                                    src="../images/about/invesco.svg"
                                    alt="marchmont"
                                />
                                <p className="copy">
                                    Invesco Real Estate is a global leader in
                                    the real estate investment management
                                    business with worldwide USD 85.0bn in real
                                    estate assets under management.
                                </p>
                                <div className="link-wrapper">
                                    <p className="volt">View website</p>
                                    <div className="parallelogram-small"></div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default About;
